import React, { useState, useEffect } from 'react'
import { UrlApi } from "../../../../services/apirest";
import {
    Typography,
    Box,
    Button,
    TextField,
    InputAdornment,
    Paper,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import PersonAddIcon from '@mui/icons-material/PersonAdd';


const FactibilidadesSisvenIdForm = ({ factibilidad, idCliente }) => {
    const navigate = useNavigate();
    const [guardado, setGuardado] = useState(false);
    const [sisvenId, setSisvenId] = useState("");
    const [disBtn, setDisBtn] = useState(false);


    const handleOnClick = async (e) => {
        setDisBtn(true)
        setGuardado(true);
        e.preventDefault();
        const clienteActualizacion = {
            sisven_id: sisvenId,
            activo: 1
        }
        try {
            const response = await fetch(`${UrlApi}/factibilidades/altaclidir/${factibilidad.factuuid}/${factibilidad.id}`, {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(clienteActualizacion),
            });

            if (!response.ok) {
                setDisBtn(false)
                throw new Error("Error al conectar con la base de datos.");
            }
            const data = await response.json();
            if (data.message !== "OK") {
                setDisBtn(false)
                throw new Error("No se actualizaron los datos.");
            } else {
                alert("Datos actualizados con éxito!")
                navigate(`/clientes/profile/${idCliente}/datos`);
            }
            setGuardado(true);
        } catch (error) {
            console.error("Error al guardar:", error);
            setDisBtn(false)
            alert("Error al guardar.")
        }
    };

    useEffect(() => {
        const handleBeforeUnload = (event) => {
            if (!guardado) {
                event.preventDefault();
                event.returnValue = "";
            }
        };

        window.addEventListener("beforeunload", handleBeforeUnload);

        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, [guardado]);


    return (
        <div>
            <Paper
                sx={{
                    position: "fixed",
                    bottom: 0,
                    left: 0,
                    width: "100%",
                    zIndex: 1300,
                    p: 2,
                    bgcolor: "background.paper",
                    boxShadow: "0 -10px 40px rgba(0,0,0,0.25)",
                    backgroundColor: "#ebebeb"

                }}
            >
                <Box sx={{ maxWidth: 600, mx: "auto" }}>
                    <Typography
                        variant="body2"
                        sx={{ color: "text.secondary", mb: 1.5 }}
                    >
                        Ingrese el ID del cliente en Sisven para darlo de alta.
                    </Typography>
                    <Box sx={{ display: "flex", gap: 1.5 }}>
                        <TextField
                            sx={{ backgroundColor: "#fff" }}
                            autoFocus
                            focused
                            type="text"
                            size="small"
                            fullWidth
                            variant="outlined"
                            placeholder="ID del cliente en Sisven..."
                            value={sisvenId}
                            onChange={(e) => {
                                const value = e.target.value;
                                if (/^\d{0,6}$/.test(value)) {
                                    setSisvenId(value);
                                    setGuardado(false);
                                }
                            }}
                            inputProps={{ maxLength: 6, inputMode: "numeric" }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <PersonAddIcon color="primary" />
                                    </InputAdornment>
                                ),
                            }}
                        />
                        <Button
                            variant="contained"
                            onClick={handleOnClick}
                            color="primary"
                            disabled={!sisvenId || disBtn}
                            sx={{ px: 4, textTransform: "none" }}
                        >
                            Guardar
                        </Button>
                    </Box>
                </Box>
            </Paper>

        </div>
    )
}

export default FactibilidadesSisvenIdForm